export const SET_PRODUCT = "SET_PRODUCT"
export const OPEN_MODAL = "OPEN_MODAL"
export const CLOSE_MODAL = "CLOSE_MODAL"
export const CLEAR_PRODUCT = "CLEAR_PRODUCT"
export const SET_PRODUCT_LIST = "SET_PRODUCT_LIST"
export const SET_PRODUCT_LIST_CALL = `${SET_PRODUCT_LIST}_CALL`
export const SET_PRODUCT_LIST_SUCCESS = `${SET_PRODUCT_LIST}_SUCCESS`
export const SET_PRODUCT_LIST_FAILURE = `${SET_PRODUCT_LIST}_SUCCESS`

export const SET_PRODUCT_IDENTIFIERS = "SET_PRODUCT_IDENTIFIERS"

export const PRODUCT_INFO = "PRODUCT_INFO"
export const PRODUCT_INFO_SUCCESS = `${PRODUCT_INFO}_SUCCESS`
export const PRODUCT_INFO_FAILURE = `${PRODUCT_INFO}_FAILURE`
export const PRODUCT_INFO_CALL = `${PRODUCT_INFO}_CALL`
